import { Util } from '../utils/util';
import { ObjectWrapperUtil } from '../utils/object.wrapper.util';
import { Injectable } from '@angular/core';
import { CommonEnums } from '../common.enums';
import { SessionFactory } from './session.factory';
import { Fldr } from '../models/datapoint/fldr';

@Injectable({
    providedIn: 'root'
})
export class UserPrivilegeFactory {
    public util: Util;
    public objectWrapperUtil: ObjectWrapperUtil;
    sessionFactory: SessionFactory;
    public privileges: Array<string>;

    private static instance: UserPrivilegeFactory;
    static getInstance() {
        if (!UserPrivilegeFactory.instance) {
            UserPrivilegeFactory.instance = new UserPrivilegeFactory();
        }
        return UserPrivilegeFactory.instance;
    }

    /**
     * @param serviceManager 
     */
    constructor() {
        this.util = Util.getInstance();
        this.objectWrapperUtil = ObjectWrapperUtil.getInstance();
        this.sessionFactory = SessionFactory.getInstance();
        this.privileges = new Array<string>();
        // this.setDefaults();
    }

    setDefaults(): void {
        this.privileges.splice(0, this.privileges.length);
    }


    packPrivileges(privileges: Array<string>): void {
        this.privileges = privileges;
    }

    checkStudioPrivileges(fldr_Id: number): boolean {

        let str: string = fldr_Id + 'ST';

        for (let i: number = 0; i < this.privileges.length; i++) {
            let privilege: string = this.privileges[i];
            let privilegeIndex = privilege.indexOf(str);
            if (privilegeIndex != CommonEnums.defaults.DEFAULT_INT_VAL)
                return false;
        }
        return true;
    }

    checkStudioWritePrivileges(fldr_Id: number): boolean {
        let str: string = fldr_Id + 'STW';

        for (let i: number = 0; i < this.privileges.length; i++) {
            let privilege: string = this.privileges[i];
            let privilegeIndex = privilege.indexOf(str);
            if (privilegeIndex != CommonEnums.defaults.DEFAULT_INT_VAL)
                return true;
        }
        return false;
    }

    checkStudioExecutePrivileges(fldr_Id: number): boolean {
        let str: string = fldr_Id + 'STE';

        for (let i: number = 0; i < this.privileges.length; i++) {
            let privilege: string = this.privileges[i];
            let privilegeIndex = privilege.indexOf(str);
            if (privilegeIndex != CommonEnums.defaults.DEFAULT_INT_VAL)
                return true;
        }
        return false;
    }

    checkSchedulerPrivileges(fldr_Id: number): boolean {

        let str: string = fldr_Id + 'SC';

        for (let i: number = 0; i < this.privileges.length; i++) {
            let privilege: string = this.privileges[i];
            let privilegeIndex = privilege.indexOf(str);
            if (privilegeIndex != CommonEnums.defaults.DEFAULT_INT_VAL)
                return false;
        }
        return true;
    }
    
    checkMonitorPrivileges(fldr_Id: number): boolean {

        let str: string = fldr_Id + 'MN';

        for (let i: number = 0; i < this.privileges.length; i++) {
            let privilege: string = this.privileges[i];
            let privilegeIndex = privilege.indexOf(str);
            if (privilegeIndex != CommonEnums.defaults.DEFAULT_INT_VAL)
                return false;
        }
        return true;
    }
    checkMetaViewPrivileges(fldr_Id: number): boolean {
        let str: string = fldr_Id + 'MV';
        for (let i: number = 0; i < this.privileges.length; i++) {
            let privilege: string = this.privileges[i];
            let privilegeIndex = privilege.indexOf(str);
            if (privilegeIndex != CommonEnums.defaults.DEFAULT_INT_VAL)
                return false;
        }
        return true;
    }
    checkStudioViewPrivileges(obj_Cd: string = '', layer_Id: number = -1): boolean {
        let str: string = CommonEnums.defaults.STRING_EMPTY;

        if (layer_Id == -1 || !layer_Id) {
            str = this.sessionFactory.fldr.fldr_Id + 'STV';
        } else {
            str = this.sessionFactory.fldr.fldr_Id + 'STV' + layer_Id;
        }

        if (this.privileges.indexOf(str) != -1)
            return false;
        return true;

    }

    checkForPrivileges(diMsgObj): boolean {

        if (diMsgObj.error_Cd == "ESM00041") {
            return false;
        }
        return true;
    }

    checkForDemoProject(nm: string): boolean {
        let str: string = "Demo";
        let stringIndex = nm.indexOf(str);
        if (stringIndex != CommonEnums.defaults.DEFAULT_INT_VAL) {
            return true;
        }
        return false;
    }


    checkForWalkthroughProject(fldr: Fldr): boolean {
        if (fldr.codeWalkthroughFlag == 'Y') {
            return true;
        }
        return false;
    }
}